export const SET_PRICES = 'SET_PRICES';

// initial state
const state = {
    list: {},
    active: {}
}

// getters
const getters = {
    prices: state => state.list,
    price: state => state.active
}

// actions
const actions = {

    getPrices: ({commit, state}, payload) => {
        axios.get(laroute.route('api.prices.index'))
            .then((response) => {
                commit(SET_PRICES, {
                    types: response.data.data
                });
            })
    }
}

// mutations
const mutations = {
    SET_PRICES: (state, payload) => {
        state.list = Object.assign({}, state.list, payload.types);
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}
